import { Themes } from './types';
import currys from './currys';
import brightworld from './brightworld';

const themes: Themes = {
  currys,
  brightworld
};

export default themes;
